import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// import styles
import { ButtonWrapper, MainWrapper, ModalStyled } from './styles';

// import components
import ProfileButton from 'components/views/user/common/ProfileButton';

const ApprovalModal = ({
	title,
	isVisible,
	onClose,
	onAccept,
	onReject,
	acceptButtonText,
	rejectButtonText,
	isAcceptDisabled,
	isRejectDisabled,
	data,
	children,
	showMask
}) => {
	const { t } = useTranslation();

	const acceptHandler = () => {
		onAccept(data);
	};

	const rejectHandler = () => {
		onReject(data);
	};

	return (
		<ModalStyled
			maskClosable={false}
			width={640}
			title={t(title)}
			visible={isVisible}
			closable={false}
			onCancel={onClose}
			mask={!!showMask}
			maskStyle={showMask}
		>
			<MainWrapper>{children}</MainWrapper>

			<ButtonWrapper>
				<ProfileButton
					onClick={rejectHandler}
					disabled={isRejectDisabled}
					width="22rem"
					height="6rem"
				>
					{t(rejectButtonText)}
				</ProfileButton>

				<ProfileButton
					theme="reject"
					onClick={acceptHandler}
					disabled={isAcceptDisabled}
					width="22rem"
					height="6rem"
				>
					{t(acceptButtonText)}
				</ProfileButton>
			</ButtonWrapper>
		</ModalStyled>
	);
};

ApprovalModal.propTypes = {
	title: PropTypes.string.isRequired,
	isVisible: PropTypes.bool.isRequired,
	onClose: PropTypes.func,
	onAccept: PropTypes.func.isRequired,
	onReject: PropTypes.func.isRequired,
	acceptButtonText: PropTypes.string,
	rejectButtonText: PropTypes.string,
	isAcceptDisabled: PropTypes.bool,
	isRejectDisabled: PropTypes.bool,
	data: PropTypes.object,
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]),
	disabledAcceptButton: PropTypes.bool,
	disabledRejectButton: PropTypes.bool,
	showMask: PropTypes.object
};

ApprovalModal.defaultProps = {
	isVisible: false,
	acceptButtonText: 'common_button_yes',
	rejectButtonText: 'common_button_no',
	isAcceptDisabled: false,
	isRejectDisabled: false,
	onClose: () => {},
	showMask: null
};

export default ApprovalModal;
